import {
  faMinus,
  faPlus,
  faChevronDown,
  faChevronRight,
  faClose,
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import { faLacrosseStick } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const colorCode = [
  {
    id: 1,
    name: 'Correct Answer',
    status: 'Correct',
    backgroundColor: '#E3FFF6',
    iconColor: '#48E0B2',
    hiddenValue: 'Correct',
    icon: <FontAwesomeIcon icon={faCheck} />,
    clickActionEnabled: true
  },
  {
    id: 8,
    name: 'Correct on previous try',
    status: 'Correct on previous try',
    backgroundColor: '#F2FFFB',
    iconColor: '#ADE0D1',
    hiddenValue: 'Correct on previous try',
    icon: <FontAwesomeIcon icon={faCheck} />,
    clickActionEnabled: false
  },
  {
    id: 2,
    name: 'Incorrect Answer',
    status: 'Incorrect',
    backgroundColor: ' #FFE3E3',
    iconColor: '#F84646',
    hiddenValue: 'Incorrect',
    icon: <FontAwesomeIcon icon={faClose} />,
    clickActionEnabled: true
  },
  {
    id: 3,
    name: 'Correct on Retry (counted as incorrect in the scoring)',
    status: 'Correct on Retry',
    backgroundColor: '#D9F6FF',
    iconColor: '#09BCF3',
    hiddenValue: 'Correct on Retry',
    icons: [
      {
        icon1: <FontAwesomeIcon icon={faCheck} />,
        icon2: <FontAwesomeIcon icon={faClose} />
      }
    ],
    clickActionEnabled: true
  },
  {
    id: 4,
    name: 'Overridden by the teacher',
    hiddenValue: 'Overridden by the teacher',
    backgroundColor: '#FFE600',
    clickActionEnabled: true
  },

  {
    id: 5,
    name: 'CR Answered',
    hiddenValue: 'CR Answered',
    backgroundColor: '#9694FF',
    clickActionEnabled: true
  },
  {
    id: 6,
    name: 'CR In-Progress',
    hiddenValue: 'CR In-Progress',
    backgroundColor: '#FC6EFF',
    clickActionEnabled: true
  },
  {
    id: 7,
    name: 'Not Answered',
    hiddenValue: 'Not Answered',
    status: 'Not Answered',
    backgroundColor: '#FFFFFF',
    border: '1px solid #000000',
    clickActionEnabled: true
  },

];

export const allCredits = [
  {
    id: 1,
    name: 'No Credits'
  },
  {
    id: 2,
    name: 'Half Credits'
  },
  {
    id: 3,
    name: 'Full Credits'
  }
];
